import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@nextui-org/react';
import Spacing from '@simppl/component/Spacing';
import Text from '@simppl/component/Text';
import { BadgeUniversityApplicationType } from '@simppl/repository-admin/badge/res';
import { type TutorApplicationType } from '@simppl/repository-admin/tutor/res';

import { isMajorNew, isUniversityNew } from '../../../utils/userUniversityUtil';

const BADGE_UNIVERSITY_INFO_COLUMNS = [
  { key: 'universityName', label: '대학' },
  { key: 'departmentName', label: '학과' },
  { key: 'proofFileUri', label: '증명 서류' },
];

const BadgeApplicationDetail = ({
  application,
}: {
  application: BadgeUniversityApplicationType;
}) => {
  return (
    <div className='flex w-full'>
      <div className='flex w-full flex-col gap-2'>
        <BadgeUniversityInfo application={application} />
      </div>
    </div>
  );
};

export default BadgeApplicationDetail;

const BadgeUniversityInfo = ({ application }: { application: BadgeUniversityApplicationType }) => {
  return (
    <div className='shadow-1 flex flex-col rounded-2xl border-[1px] p-3'>
      <Text
        as='Title'
        size={1}
        weight='Bold'
        color='text-Blue-1'
      >
        뱃지 신청 대학 목록
      </Text>
      <Spacing height={16} />

      <Table>
        <TableHeader columns={BADGE_UNIVERSITY_INFO_COLUMNS}>
          {(column) => <TableColumn key={column.key}>{column.label}</TableColumn>}
        </TableHeader>
        <TableBody>
          {application.universities.map(({ universityName, majorName, proofFileUris }, idx) => {
            const isMajorCreateStatus =
              application.existencies && isMajorNew(application.existencies[idx]);

            const isUniversityCreateStatus =
              application.existencies && isUniversityNew(application.existencies[idx]);

            return (
              <TableRow key={universityName}>
                <TableCell className={isUniversityCreateStatus ? 'text-red-500' : ''}>
                  {universityName}
                  {isUniversityCreateStatus && '(신규)'}
                </TableCell>
                <TableCell className={isMajorCreateStatus ? 'text-red-500' : ''}>
                  {majorName}
                  {isMajorCreateStatus && '(신규)'}
                </TableCell>
                <TableCell>
                  {proofFileUris.map((uri, idx) => (
                    <FileDownloadButton
                      key={uri}
                      fileUrl={uri}
                      fileName={`{대학 증명 ${idx}번 파일`}
                    />
                  ))}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

const FileDownloadButton = ({ fileName, fileUrl }: { fileName: string; fileUrl: string }) => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName; // 다운로드될 파일명 지정
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return <button onClick={handleDownload}>파일 다운로드</button>;
};
